import { SelectOption } from '@anytag/shared-types';
import { SelectProps } from './types';
import { MultiSelect } from './mutiple-select';
import { SingleSelect } from './single-select';
import { SelectProvider } from './select-context';

export const Select = <TOption extends SelectOption<string>>(props: SelectProps<TOption>) => (
  <SelectProvider<TOption> selectProps={props}>
    {props.multiple ? <MultiSelect<TOption> /> : <SingleSelect<TOption> />}
  </SelectProvider>
);
